<template>
  <lida-table
    :propscolumns="columns"
    :data="items"
    :sortStatus="false"
  ></lida-table>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import idopColor from '@/mixins/idopColor'
export default {
  name: 'electronic-games-makers',
  mixins: [idopColor],
  data () {
    return {
      items: [],
    }
  },
  computed: {
    ...mapGetters(['getmember', 'getpermission']),
    columns () {
      let object = {
        gamehall: {
          title: '游戏商简称',
          key: 'gamehall',
          align: 'center',
          className: "infor-column"
        },
        textidop: {
          title: '狀態',
          key: 'textidop',
          align: 'center',
          render: (h, params) => {
            return h('span', {
              class: {
                ...this.idopColor(params.row.idop)
              }
            }, params.row.textidop)
          }
        },
        idop: {
          title: '啟用/停用',
          key: 'textidop',
          align: 'center',
          width: 150,
          render: (h, params) => {
            const modifyclick = (val) => {
              this.$Modal.confirm({
                title: "提示信息",
                content: "确认是否要更改 ?",
                onOk: res => this.modifyElectronicGameMaker(val)
              });
            }
            return h('Button', {
              props: {
                type: params.row.idop == '1' ? 'error' : 'success'
              },
              on: {
                click: () => modifyclick(params.row)
              }
            },
              params.row.idop == '1' ? '停用' : '啟用'
            )
          }
        },
        gamelist: {
          title: '遊戲列表',
          key: 'textidop',
          align: 'center',
          width: 200,
          render: (h, params) => {
            const pushGamelist = (val) => this.$router.push({ name: 'electronic-games-list', query: { makerid: val } })

            return h('Button', {
              props: {
                type: 'info'
              },
              on: {
                click: () => pushGamelist(params.row.hallsid)
              }
            }, '遊戲列表')
          }
        }
      }
      if (this.getpermission.gameswitch[3] != '1') delete object.idop
      return object
    }
  },
  created () {
    this.getElectronicGameMaker()
  },
  methods: {
    ...mapActions(['updateExgameReset']),
    async getElectronicGameMaker () {
      try {
        const res = await this.$axios.cq9.getElectronicGameMaker()
        if ('status' in res && res.status === 0) return
        this.items = res.map(it => {
          it.textidop = it.idop == 1 ? '啟用' : '停用'
          return it
        })
      } catch (error) {
        this.$Message.error('网路异常');
      }
    },
    async modifyElectronicGameMaker (value) {
      const obj = {
        loid: this.getmember.pid,
        hallsitem: [{
          hallsid: value.hallsid,
          idop: value.idop == '1' ? '0' : '1'
        }]
      }
      if (!obj.hallsitem.length) return this.$Message.warning("请选择修改游戏商");

      try {
        const res = await this.$axios.cq9.modifyElectronicGameMaker(obj)
        if (res.status === 1) {
          this.$Message.success("已更改");
          this.modalstate = false;
          this.getElectronicGameMaker()
          this.updateExgameReset()
        }
      } catch (error) {
        console.log(error);
        this.$Message.error('cq9修改游戏商开关错误');
      }
    }
  }
}
</script>